import { ROUTE_PATH } from "../../app/constants";
import { 
    Header, 
    Paragraph, 
    NavigationLinkButton 
} from "../../components/RegularComponents";

export const MraChoosePrincipalBroker = () => {

    return (
        <>
        <div className="container">
            <div className="row bottomMarginMedium">
                <div className="col-lg-8">
                    <Header 
                        id="choose-principal-broker-header"
                        header={"Choose a new principal broker"}
                    />
                </div>
            </div>

            <div className="row bottomMarginMedium">
                <div className="col-lg-8">
                    <Paragraph
                        id="choose-principal-broker-paragraph-text"
                        text={[
                            `Choose a principal broker at your brokerage making sure that they are a partner, director or officer at your brokerage.`,
                            "The principal broker is the only person who can apply for a brokerage, mortgage broker, and associate mortgage broker licences."
                        ]}
                    />
                </div>
            </div>

            <div className="row bottomMarginNormal">
                <div className="col-lg-8">
                     <NavigationLinkButton 
                        onClick={() => {
                            window.location.assign(ROUTE_PATH.LAUNCHPAGE_MORTGAGE)
                        }}
                        text="Back to start"
                    />
                </div>
            </div>
        </div>
        </>
    )
}
